import { activateI18n } from '@retail/funnel-components';
import { messages as sellOnlyMessages } from '../translations/AH-sell-only/nl/messages';
import { messages as retailMessages } from '../translations/autohero-common/nl/messages';

activateI18n('nl', {
  ...retailMessages,
  ...sellOnlyMessages,
});
